import {
  Dialog,
  DialogBody,
  DialogButton,
  DialogButtons,
  DialogCloseX,
  DialogContent,
  DialogHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import type { MouseEventHandler } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  open: boolean;
  setOpen: (o: boolean) => void;
  removeFollower: MouseEventHandler<HTMLButtonElement>;
  displayName: string;
}

const polyglotPrefix =
  "pages.data_sharing.manage_follower.remove_follower.dialog."

/*
 * renders a dialog asking the user to confirm that they want to delete a follower
 */
export function RemoveFollowerDialog(props: Props) {
  const {
    setOpen, open: isOpen, removeFollower, displayName,
  } = props

  const polyglot = usePolyglot()

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setOpen}
    >
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}title`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogBody>
          <div>
            {polyglot.t(
              `${polyglotPrefix}description_one`,
              { displayName },
            )}
          </div>
          <div>
            {polyglot.t(`${polyglotPrefix}description_two`)}
          </div>
        </DialogBody>
        <DialogButtons>
          <DialogButton
            id="confirm-remove-follower-btn"
            stylePreset="destructive"
            onClick={removeFollower}
          >
            {polyglot.t(`${polyglotPrefix}remove_cta`)}
          </DialogButton>
          <DialogButton
            stylePreset="primary"
          >
            {polyglot.t(`${polyglotPrefix}cancel_cta`)}
          </DialogButton>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}
